import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MyProfileService } from '../services/my-profile.service';
import { of, pipe } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '../services/alert.service';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {

    constructor(private router: Router,
      private authService:AuthService,
      private myProfileService: MyProfileService,
      private alertService: AlertService) { }

      async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
          const params = new URLSearchParams(window.location.search);
          const facialToken = params.get('facialToken');
          let webview =  false

          const userAgent = navigator.userAgent.toLowerCase();    
          if (
            userAgent.indexOf("wv") >-1 || userAgent.indexOf("webview") >-1
          ) {
            webview = true;
          }
          if (window.location.href.split('?')[1] != null && window.location.href.split('?')[1].split('=')[0] == 'session') {
              let token = window.location.href.split('?')[1].split('=')[1];

                // checa se tem feng, se tiver loga o usuário
                this.myProfileService.checkToken(token).pipe(
                  catchError((error: any) => {
                    this.alertService.toast({  icon: 'error', title: 'Erro', text: error.error.error.errors[0].msg});
                    return of(error);
                  })
                )
                .subscribe((res: any) => {
                  if (res.error != null == false) {
                    this.alertService.toast({  icon: 'success', title: 'Usuário logado', text: 'Usuário logado'});
                    let user = res.user;
                    user.token = res.token;
                    user.phone = res.user.phones;
                    delete user.phones;

                    this.authService.saveCustomer(user);
                  }
                  if (!this.authService.isLoggednIn()) {
                        this.authService.logout();
                        this.router.navigate(['/auth/login']);
                    return false;
                  } else {
                    return true;
                  }
                });


          } else if(facialToken && webview == false){
            this.myProfileService.checkToken(facialToken).pipe(
              catchError((error: any) => {
                this.alertService.toast({  icon: 'error', title: 'Erro', text: error.error.error.errors[0].msg});
                return of(error);
              })
            )
            .subscribe((res: any) => {
              if (res.error != null == false) {
                this.alertService.toast({  icon: 'success', title: 'Sucesso', text: 'Usuário logado'});
                let user = res.user;
                user.token = res.token;
                user.phone = res.user.phones;
                delete user.phones;
                this.authService.saveCustomer(user);

                this.router.navigate(['/reconhecimento-facial']);
              }else{
                this.alertService.toast({  icon: 'error', title: 'Erro', text: res.error.errors[0].msg});
              }
            });
               //  this.checkFacial()  
              
          }else {
            if (!this.authService.isLoggednIn()) {
                  this.authService.logout();
                  this.router.navigate(['/auth/login'], { queryParams: { redirect: state.url }});
              return false;
            } else {
              return true;
            }
          }
        return false
      }


}
